/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState from './initialState';
var backendStatusError = produce(function (draft, action) {
  var _draft$experimentId$w, _draft$experimentId, _draft$experimentId$t, _draft$experimentId2;
  var _action$payload = action.payload,
    experimentId = _action$payload.experimentId,
    error = _action$payload.error;
  draft[experimentId] = {
    status: {},
    loading: false,
    error: error,
    workerStatus: (_draft$experimentId$w = (_draft$experimentId = draft[experimentId]) === null || _draft$experimentId === void 0 ? void 0 : _draft$experimentId.workerStatus) !== null && _draft$experimentId$w !== void 0 ? _draft$experimentId$w : {},
    taskWorkers: (_draft$experimentId$t = (_draft$experimentId2 = draft[experimentId]) === null || _draft$experimentId2 === void 0 ? void 0 : _draft$experimentId2.taskWorkers) !== null && _draft$experimentId$t !== void 0 ? _draft$experimentId$t : {}
  };
}, initialState);
export default backendStatusError;